import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import SaveIcon from "@mui/icons-material/Save"
import { Stack } from "@mui/material"
import { ReactElement } from "react"

import { GRID_SPACING } from "../../themes/defaultThemeParams"
import AppButton from "../buttons/appButton"

interface IFormNavigationProps {
    onClickBack?: () => void
    onClickNext?: () => void
    onClickMiddle?: () => void
    backText?: string
    nextText?: string
    middleText?: string
    nextDisabled?: boolean
    backDisabled?: boolean
    middleDisabled?: boolean
    nextIcon?: ReactElement
    middleIcon?: ReactElement
    backIcon?: ReactElement
    allDisabled?: boolean
}

/** Component used to display back and next buttons for a form page */
const FormNavigation = ({
    onClickBack = undefined,
    onClickNext = undefined,
    backText = "Back",
    nextText = "Next",
    nextDisabled = false,
    backDisabled = false,
    nextIcon = undefined,
    backIcon = undefined,
    onClickMiddle = undefined,
    middleText = "Save draft",
    middleDisabled = false,
    middleIcon = undefined,
    allDisabled = false,
}: IFormNavigationProps): ReactElement => (
    <Stack direction="row" spacing={GRID_SPACING} justifyContent="flex-end">
        {onClickBack && (
            <AppButton
                size="large"
                variant="outlined"
                startIcon={backIcon ?? <NavigateBeforeIcon />}
                onClick={onClickBack}
                disabled={backDisabled || allDisabled}
            >
                {backText}
            </AppButton>
        )}
        {onClickMiddle && (
            <AppButton
                size="large"
                variant="outlined"
                endIcon={middleIcon ?? <SaveIcon />}
                onClick={onClickMiddle}
                disabled={middleDisabled || allDisabled}
            >
                {middleText}
            </AppButton>
        )}
        {onClickNext && (
            <AppButton
                size="large"
                variant="contained"
                endIcon={nextIcon ?? <NavigateNextIcon />}
                onClick={onClickNext}
                disabled={nextDisabled || allDisabled}
            >
                {nextText}
            </AppButton>
        )}
    </Stack>
)

FormNavigation.defaultProps = {
    nextDisabled: false,
    backDisabled: false,
    onClickBack: undefined,
    onClickNext: undefined,
    backText: "Back",
    nextText: "Next",
    nextIcon: undefined,
    backIcon: undefined,
    onClickMiddle: undefined,
    middleText: "Save draft",
    middleDisabled: false,
    middleIcon: undefined,
    allDisabled: false,
}

export default FormNavigation
